import { Component, input } from '@angular/core';

export interface RoadmapItem {
  quarter: string;
  title: string;
  desc: string;
}

@Component({
  selector: 'gs-roadmap-card',
  templateUrl: './gs-roadmap-card.html',
  styleUrl: './gs-roadmap-card.scss',
})
export class GsRoadmapCard {
  item = input.required<RoadmapItem>();
  cardIndex = input(0);
}
